export interface AnnotationMetadata {
  text: string
  prefix: string
  suffix: string
  fragments: HTMLAnchorFragment[] | PDFAnchorFragment[]
  engine?: EAnnotationEngine
}

export interface HTMLAnchorFragment {
  text: string
  startPath: string
  startOffset: number
  endPath: string
  endOffset: number
}

export interface PDFAnchorFragment {
  pageIndex: number
  text: string // highlighted text
  rects: PdfRect[]
}

export interface PdfRect {
  leftOffset: number
  topOffset: number
  width: number
  height: number
  text?: string // token text
}

export enum EAnnotationEngine {
  HTML = 'html',
  PDF = 'pdfjs-canvas',
}

export interface AnnotationSelectionEventDetail {
  metadata: AnnotationMetadata
}

export type AnnotationSelectionEvent =
  CustomEvent<AnnotationSelectionEventDetail>

export interface SearchResult {
  range: Range
  confidence: number
  method: 'xpath' | 'text-single' | 'text-context'
}

export type PdfViewportLike = {
  width: number
  height: number
  convertToViewportPoint(x: number, y: number): [number, number]
  convertToPdfPoint(x: number, y: number): [number, number]
}

export type PdfTextItemLike = {
  str: string
  transform: number[] // at least length 6
  width: number
  height: number
}

// pdf.js also returns TextMarkedContent which does NOT have these fields
export type PdfTextMarkedContentLike = {
  type: string
  // pdf.js has `id` and other fields depending on version; keep it permissive
  [key: string]: unknown
}

export type PdfTextContentLike = {
  items: Array<PdfTextItemLike | PdfTextMarkedContentLike>
}

export type PdfPageProxyLike = {
  getTextContent(): Promise<PdfTextContentLike>
  getViewport(params: { scale: number }): PdfViewportLike
}
